import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-stepper', {
    month: {
        1: 'месяц',
        2: 'месяца',
        5: 'месяцев',
    },
    year: {
        1: 'год',
        2: 'года',
        5: 'лет',
    },
    increase: 'Увеличить',
    decrease: 'Уменьшить',
    value: 'Значение',
    max: 'Максимум',
    min: 'Минимум',
});
